var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel__slide-index"},[_c('aha-icon',{attrs:{"name":"slide"}}),_c('span',[_vm._v(_vm._s(_vm.slideIndex(_vm.slideId)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }